import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsMapComponent } from './fields-interventions-map.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {MapLayersControlModule} from '../../map/map-layers-control/map-layers-control.module';
import {DxLoadPanelModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsMapComponent],
  imports: [
    CommonModule,
    LeafletModule,
    MapLayersControlModule,
    DxLoadPanelModule
  ],
  exports: [FieldsInterventionsMapComponent]
})
export class FieldsInterventionsMapModule { }
